<template>
  <div style="margin-bottom: 20px; font-size: 12px">
    <br />
    <ChooseCityComponent class="gadget"></ChooseCityComponent>
    <ExchangeRateComponent class="gadget"></ExchangeRateComponent>
    <WeiboHotTopicsComponent class="gadget"></WeiboHotTopicsComponent>
    <LinksComponent class="gadget"></LinksComponent>
    <AdminSidebarComponent class="gadget"></AdminSidebarComponent>
    <TermPrivacyComponent class="gadget"></TermPrivacyComponent>
  </div>
</template>

<script>
import ChooseCityComponent from "./ChooseCityComponent.vue";
import ExchangeRateComponent from "./ExchangeRateComponent.vue";
import WeiboHotTopicsComponent from "./WeiboHotTopicsComponent.vue";
import LinksComponent from "./LinksComponent.vue";
import AdminSidebarComponent from "@/components/AdminSidebarComponent";
import TermPrivacyComponent from "@/components/TermPrivacyComponent";

export default {
  components: {
    ChooseCityComponent,
    TermPrivacyComponent,
    ExchangeRateComponent,
    WeiboHotTopicsComponent,
    LinksComponent,
    AdminSidebarComponent
  }
};
</script>
